if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();

        console.log('[Localization] Init');

        this.mql = window.matchMedia('(min-width: 750px)');
        this.header = document.querySelector('.header-wrapper');

        this.elements = {
          input: this.querySelector('input[name="country_code"], input[name="locale_code"]'),
          button: this.querySelector('button.localization-form__select'),
          panel: this.querySelector('.disclosure__list-wrapper'),
          search: this.querySelector('input[name="country_filter"]'),
          closeButton: this.querySelector('.country-selector__close-button'),
          resetButton: this.querySelector('.country-filter__reset-button'),
          searchIcon: this.querySelector('.country-filter__search-icon'),
          liveRegion: this.querySelector('#sr-country-search-results'),
        };

        if (!this.elements.button || !this.elements.panel) {
          console.warn('[Localization] Required elements missing');
          return;
        }

        /* EVENTS */
        this.elements.button.addEventListener('click', () => this.toggleSelector());
        this.addEventListener('keydown', (e) => this.onKeyDown(e));
        this.addEventListener('keyup', (e) => this.onKeyUp(e));
        this.addEventListener('focusout', (e) => this.onFocusOut(e));

        this.querySelectorAll('a').forEach((item) => {
          item.addEventListener('click', (e) => this.onItemClick(e));
        });

        if (this.elements.search) {
          this.elements.search.addEventListener('keyup', () => this.filterCountries());
        }

        if (this.elements.closeButton) {
          this.elements.closeButton.addEventListener('click', () => this.hidePanel());
        }

        if (this.elements.resetButton) {
          this.elements.resetButton.addEventListener('click', (e) => {
            e.preventDefault();
            this.resetFilter();
          });
        }

        /* FORCE NZ */
        this.setCountryFromURL();
      }

      /* ------------------ FORCE COUNTRY ------------------ */
      setCountryFromURL() {
        if (!location.pathname.startsWith('/en-nz')) return;

        console.log('[Localization] /en-nz detected');

        const nzItem = this.querySelector('a[data-value="NZ"]');
        if (!nzItem) return;

        if (this.elements.input) {
          this.elements.input.value = 'NZ';
        }

        const span = this.elements.button.querySelector('span');
        if (span) {
          span.textContent = 'New Zealand | NZD $';
        }

        this.querySelectorAll('a').forEach((item) => {
          item.removeAttribute('aria-current');
          item.querySelector('.icon-checkmark')?.classList.add('visibility-hidden');
        });

        nzItem.setAttribute('aria-current', 'true');
        nzItem.querySelector('.icon-checkmark')?.classList.remove('visibility-hidden');

        console.log('[Localization] NZ forced');
      }

      /* ------------------ TOGGLE ------------------ */
      toggleSelector() {
        const isOpen = this.elements.button.getAttribute('aria-expanded') === 'true';

        console.log('[Localization] Toggle', !isOpen);

        this.elements.button.setAttribute('aria-expanded', String(!isOpen));
        this.elements.panel.toggleAttribute('hidden', isOpen);

        document.body.classList.toggle('overflow-hidden-mobile', !isOpen);
        document.querySelector('.menu-drawer')?.classList.toggle('country-selector-open', !isOpen);
      }

      hidePanel() {
        console.log('[Localization] Close');

        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);

        document.body.classList.remove('overflow-hidden-mobile');
        document.querySelector('.menu-drawer')?.classList.remove('country-selector-open');
      }

      /* ------------------ ITEM CLICK ------------------ */
      onItemClick(event) {
        event.preventDefault();

        const value = event.currentTarget.dataset.value;
        console.log('[Localization] Selected:', value);

        if (this.elements.input) {
          this.elements.input.value = value;
        }

        const form = this.querySelector('form');
        if (form) {
          console.log('[Localization] Submitting form');
          form.submit();
        }
      }

      /* ------------------ FILTER ------------------ */
      normalizeString(str) {
        return str.normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase();
      }

      filterCountries() {
        if (!this.elements.search) return;

        const searchValue = this.normalizeString(this.elements.search.value);
        const items = this.querySelectorAll('a');

        items.forEach((item) => {
          const name = this.normalizeString(
            item.querySelector('.country')?.textContent || ''
          );
          item.parentElement.classList.toggle('hidden', !name.includes(searchValue));
        });

        console.log('[Localization] Filter:', searchValue);
      }

      resetFilter() {
        if (!this.elements.search) return;
        this.elements.search.value = '';
        this.filterCountries();
      }

      /* ------------------ KEYBOARD ------------------ */
      onKeyDown(event) {
        if (event.key === 'Escape') {
          this.hidePanel();
          this.elements.button.focus();
        }
      }

      onKeyUp(event) {
        if (event.code === 'Space') {
          event.preventDefault();
          this.toggleSelector();
        }
      }

      onFocusOut(event) {
        if (!this.contains(event.relatedTarget)) {
          this.hidePanel();
        }
      }
    }
  );
}
